<template>
  <div class="row d-flex justify-content-center">
    <div class="the-box text-center">
      <form class="form-horizontal pt-4 pl-4">
        <div class="date text-center">
          <label class="control-label text-center" for="fromDate">
            <b>Start Date</b>
          </label>
          <input
            type="date"
            v-model="form.start_date"
            class="form-control text-center"
            required
          />
        </div>

        <div class="date text-center">
          <label class="control-label text-center pt-4" for="toDate">
            <b>End Date</b>
          </label>
          <input
            type="date"
            v-model="form.end_date"
            class="form-control text-center"
            required
          />
        </div>

        <div class="form-group">
          <label for="agents">
            <b>Agent</b>
          </label>
          <select class="form-control" v-model="form.agent_title">
            <option value selected="selected">All Agents</option>
            <option
              v-for="agent in agents"
              :key="agent.id"
              :value="agent.title"
              >{{ agent.full_name }}</option
            >
          </select>
        </div>

        <table v-if="totalAmount" class="table">
          <tr>
            <th>Total Amount:</th>
            <td>₦{{ new Intl.NumberFormat().format(totalAmount) }}</td>
          </tr>
          <tr>
            <th>Transaction Count:</th>
            <td>{{ new Intl.NumberFormat().format(totalCount) }}</td>
          </tr>
          <tr v-if="!reset">
            <th colspan="2">
              <JsonCSV v-if="transactions.length > 0" :data="transactions">
                <button class="btn btn-success btn-xs" @click="restart()">
                  Export Report as CSV
                </button>
              </JsonCSV>
            </th>
          </tr>
        </table>

        <button
          :disabled="loading"
          v-if="reset"
          id="generatebtn"
          @click="generateCSV"
          class="btn btn-primary"
        >
          <div v-if="loading" class="spinner-grow" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <template v-else>
            Generate Report
            <i class="fa fa-download"></i>
          </template>
        </button>

        <div v-show="formError" class="alert alert-danger" role="alert">
          {{ this.formError }}
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import JsonCSV from 'vue-json-csv'

export default {
  data() {
    return {
      loading: false,
      username: sessionStorage.getItem('username'),
      user_id: sessionStorage.getItem('userId'),
      passcode: CryptoJS.HmacSHA512(
        sessionStorage.getItem('username'),
        '123NDSx'
      ).toString(),
      agents: [],
      reset: true,
      form: {
        start_date: null,
        end_date: null,
        agent_title: ''
      },
      service: 'power',
      transactions: [],
      totalAmount: null,
      totalCount: null,
      formError: null
    }
  },
  components: {
    JsonCSV
  },
  methods: {
    fetchAgents() {
      this.loading = true

      const form = JSON.stringify({
        username: this.username,
        user_id: this.user_id,
        passcode: this.passcode,
        action: 'get_agents'
      })

      fetch('https://irecharge.com.ng/api/reports/get_agents.php', {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: form
      })
        .then(res => res.json())
        .then(data => {
          if (data.status == 0) {
            this.agents = data.agents
            this.loading = false
          } else if (data.status == '-1') {
            this.$router.push('/login')
          }
        })
        .catch(err => {
          console.log(err)
          this.$router.push('/login')
        })
    },

    restart() {
      this.reset = true
    },

    generateCSV() {
      if (this.form.start_date == null) {
        this.formError = 'Start date is required'
        return
      } else if (this.form.end_date == null) {
        this.formError = 'End date is required'
        return
      }

      this.loading = true
      let form = JSON.stringify({
        action: 'get_transactions',
        username: this.username,
        service: this.service,
        user_id: this.user_id,
        start_date: this.form.start_date,
        end_date: this.form.end_date,
        passcode: this.passcode,
        agent_title: this.form.agent_title
      })

      fetch('https://irecharge.com.ng/api/reports/get_transactions.php', {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: form
      })
        .then(res => res.json())
        .then(data => {
          console.log(data.status)
          if (data.status == 0) {
            this.totalAmount = data.total_amount
            this.totalCount = data.total_count
            data.transactions && data.transactions.forEach(transaction => {
              // loop the response with new header
              var result = {
                'Transaction ID': transaction.transaction_id,
                'Meter Number': transaction.receiver,
                'Meter Token': transaction.token,
                'Amount (NGN)': transaction.amount,
                'Net (NGN)': transaction.amount_paid,
                'Commission': transaction.commission,
                'User ID': transaction.user,
                'Date': transaction.date,
                'Status': transaction.status
              }
              this.transactions.push(result)
            })

            var spacer = {
              'Transaction ID': '',
              'Meter Token': ''
            }
            this.transactions.push(spacer)

            spacer = {
              'Transaction ID': '',
              'Meter Token': ''
            }
            this.transactions.push(spacer)

            spacer = {
              'Transaction ID': 'Total Amount',
              'Meter Token': 'Total Count'
            }
            this.transactions.push(spacer)

            spacer = {
              'Transaction ID': '₦' + this.totalAmount,
              'Meter Token': this.totalCount
            }
            this.transactions.push(spacer)
            console.log(this.transactions)
            this.loading = false
            this.reset = false
          } else if (data.status == '-1') {
            this.loading = false;
            sessionStorage.clear();
            this.$router.push('/login')
          }
        })
        .catch(err => {
        this.loading = false;
          console.log(err);
          this.$router.push('/login')
        })
    }
  },
  mounted() {
    this.fetchAgents()
  }
}
</script>
<style scoped>
input[type='date'] {
  background: #fff
    url(https://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/calendar_2.png)
    97% 50% no-repeat;
}
</style>
